import axios from 'axios';
import { API_URL } from "../../configs/siteConfig";

const _api = {

    allSponsorTypes: async function (token) {
        return axios.get(API_URL+'Sponsor/SponsorTypes',{
            headers: 
            { 
                'content-type': 'application/x-www-form-urlencoded' ,
                'Authorization': 'Bearer ' + token,
            },
        })
       .then(function (response) {
            return response?.data;
        })
       .catch(function (error) {
            return error?.response.data;
        });
   },

   getSponsors: async function (data) {
        return axios.get(`${API_URL}Sponsor/GetSponsors?auctionId=${data.auctionId}`,{
            headers: 
            { 
                'content-type': 'application/x-www-form-urlencoded' ,
                'Authorization': 'Bearer ' + data.token,
            },
        })
       .then(function (response) {
            return response?.data;
        })
       .catch(function (error) {
            return error?.response.data;
        });
   },
    
}

export default _api;